import {CSSProperties, FC, ReactNode} from 'react';
import "./AbsolutePosition.css"

interface IAbsolutePositionProps {
    children: ReactNode;
    style?: CSSProperties;
    zIndex: number;
    className?: string;
}

const AbsolutePosition: FC<IAbsolutePositionProps> = ({className, children, style, zIndex}) => {
    return (
        <div style={{...style, zIndex: `${zIndex}`}} className={`${className ? className : "" } ui__component--absolute__position`}>
            {children}
        </div>
    );
};

export default AbsolutePosition;